import { Suspense, useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { useLenisAutoResize } from '@hooks/useLenisAutoResize';
import { useScrollToTopSearch } from '@hooks/useScrollToTopSearch';
import { useScrollToTopPathname } from '@hooks/useScrollToTopPathname';

import CookiesModal from '@components/CookiesModal/CookiesModal';

import Header from '../Header/Header';
import Footer from '../Footer/Footer';

const Loader = () => <div>Loading...</div>;
// <Suspense fallback={<Loader />}>

const Layout = () => {
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useLenisAutoResize();
  useScrollToTopSearch();
  useScrollToTopPathname();

  return (
    <div className="wrapper">
      <Header />

      <main className="main">
        <Suspense>
          <Outlet />
        </Suspense>
      </main>

      <Footer />

      <CookiesModal />
    </div>
  );
};

export default Layout;
